import React, { useState, useEffect, useReducer } from 'react';
import { useLanguage } from '../../../context/language';
import { getStrLang } from '../../Translate';
import { getAceiteTermos, postStripeCC, postPrimefyCC, postRasPayCC, postAsaasCC ,postBigoPayCC, postCCX, getDeposit} from '../../../api/fastcoinService';
import Loading from '../../../assets/loading.gif';
import toast, { Toaster } from 'react-hot-toast';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import { IoChevronBackOutline } from 'react-icons/io5';

import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardNumberElement, CardExpiryElement, CardCvcElement, useElements, useStripe } from '@stripe/react-stripe-js';
import InstalmentControl from './InstalmentControl'; 
import { useInstalment } from '../../../context/InstalmentContext';

// const stripePromise = loadStripe('pk_test_51My17yGpCEmlya7PYeFBgCaXbpHI1nQgDleA6IeWmA7aIwfHcHjYH5cOG6GLLhbpAv3GQQ7QXGvpFN5pef3FjcuK00Mp2Z5nGK');
const stripePromise = loadStripe('pk_live_51My17yGpCEmlya7Pcg5Tt7tu6zskfmGwZRzWqMHP10KfM4zPdp2fGcrkNbLI0dr1RAwAxH17cn0dD5klxDEoCzT4002sHMGuxX');


const CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            width: '100%',
            color: "#32325d",
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            '::placeholder': {
                color: "#aab7c4"
            },
            ':-webkit-autofill': {
                color: '#32325d',
            },
        },
        invalid: {
            color: "#fa755a",
            iconColor: "#fa755a"
        }
    }
};

//for stripe
const CheckoutForm = ({ lang, postStripePaymentMethod,setLoadingInfo,loadingInfo }) => {
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }
        setLoadingInfo(true)
        const cardNumberElement = elements.getElement(CardNumberElement);
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardNumberElement,
        });

        if (error) {
            console.log('[error]', error);
            setLoadingInfo(false)
        } else {
            console.log('[PaymentMethod]', paymentMethod);
            postStripePaymentMethod(paymentMethod.id);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className='form-group'>
                <label htmlFor="card_number">{getStrLang(lang.nameLang, "card_number")}</label>
                <CardNumberElement options={CARD_ELEMENT_OPTIONS} className='form-control' />
            </div>
            <div className='form-group'>
                <label htmlFor="expire_date">{getStrLang(lang.nameLang, "expire_date")}</label>
                <CardExpiryElement options={CARD_ELEMENT_OPTIONS} className='form-control' />
            </div>

            <div className='form-group'>
                <label htmlFor="expire_date">{getStrLang(lang.nameLang, "cvv_number")}</label>
                <CardCvcElement options={CARD_ELEMENT_OPTIONS} className='form-control' />
            </div>

            <button type='submit' disabled={loadingInfo} className='btn btn-primary btn-block mt-3'>{getStrLang(lang.nameLang, "pay")}</button>
        </form>
    );
};
const StripeCC = (props) => {

    const { translate, lang, orderFromDeposit } = useLanguage();

    const country = sessionStorage.getItem("country").toLocaleLowerCase();


    const [loadingInfo, setLoadingInfo] = useState(false);
    const [loadingInfo2, setLoadingInfo2] = useState(false);
    const [card_holder_name, setCardHolderName] = useState("")
    const [card_number, setCardNumber] = useState("")
    const [cvv_number, setCvvNumber] = useState("")
    const [expire_date, setExpireDate] = useState("")
    const [isShowUserForm, setIsShowUserForm] = useState(false)
    const minWidth = window.innerWidth <= 768 ? "90%" : "70%";
    const { instalment } = useInstalment(); 

    const [is3DS, setIs3DS] = useState(false)
    const [redirectUrl, setRedirectUrl] = useState('')
    const [txnId, setTxnId] = useState('')

    // Address fields for CCX
    const [showAddressForm, setShowAddressForm] = useState(false)
    const [addressData, setAddressData] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        {
            full_address: sessionStorage.getItem('full_address') || "",
            city: "",
            state: "",
            zip: ""
        }
    );

    const [formInput, setFormInput] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        {
            gender: "1",
            birthdate: "",
            zip_code: "",
            city: "",
            state: "AC",
        }
    );


    useEffect(() => {
        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
                .then(res => {
                    if (res !== undefined) {
                        props.setShowTermos(false);
                        sessionStorage.setItem("ipNumber",res.ip)
                    } else {
                        props.setShowTermos(true);
                    }
                    translate();
                })
                .catch(err => {
                    if (err.error.includes("Could not find")) {
                        console.log(err);
                    } else {
                        console.log(err);
                        alert("Please talk with the administrator");
                    }
                    props.setShowTermos(true);
                })
        }
        if (orderFromDeposit !== "") {
            validarTermos();
        }
        if (props.provider_name === "ccr") {
            setIsShowUserForm(true)
        } else {
            setIsShowUserForm(false)
        }

        // For CCX, fetch deposit data to prefill address
        if (props.provider_name === "CCX") {
            setShowAddressForm(true)
        }

    }, []);


    useEffect(() => {
        translate();
        // if (country === "mx" || country === "ar") {
        //     setIsVirtual(true)
        // }
    }, [translate, country]);

    const callCard = (e) => {
        e.preventDefault();
        setLoadingInfo(true);
        if (props.provider_name === "ccp") {///for cc primify
            postPrimefyCC(sessionStorage.getItem("order_no"), {
                "name": card_holder_name,
                "number": card_number,
                "cvv": cvv_number,
                "expirationMonth": expire_date.split("/")[0],
                "expirationYear": expire_date.split("/")[1],
            })
                .then(res => {
                    if (res !== undefined) {
                        setLoadingInfo(false)
                        if (res.redirectUrl) {
                            window.location = res.redirectUrl;
                        } else {
                            window.location.replace(getURLBackToPanel());
                        }
                    } else {

                    }
                })
                .catch(err => {
                    if (err.response?.data?.error === "invalid_bin") {
                        toast.error(getStrLang(lang.nameLang, "invalid_bin"))
                    } else if (err.response?.data?.error === "invalid_bin") {
                        toast.error(`${getStrLang(lang.nameLang, "invalid_card_type")}`)
                    } else if (err.response?.data?.error === "invalid_document_id") {
                        toast.error(`${getStrLang(lang.nameLang, "invalid_doc_id")} ${err.response?.data?.document_needed}`)
                    } else {
                        toast.error(err.response?.data?.error)
                    }
                    console.log(err.toString());
                }).finally(() => {
                    setLoadingInfo(false);
                    translate();
                });
        }else if (props.provider_name === "ccb") {///for cc bigopay
            postBigoPayCC(sessionStorage.getItem("order_no"), {
                "name": card_holder_name,
                "number": card_number,
                "cvv": cvv_number,
                "expirationMonth": expire_date.split("/")[0],
                "expirationYear": expire_date.split("/")[1],
            })
                .then(res => {
                    if (res !== undefined) {
                        setLoadingInfo(false)
                        if (res.redirect_url) {
                            // kick off 3DS iframe + polling
                            setRedirectUrl(res.redirect_url)
                            setTxnId(res.txnId)
                            setIs3DS(true)
                        } else {
                            window.location.replace(getURLBackToPanel())
                        }
                    } else {

                    }
                })
                .catch(err => {
                    if (err.response?.data?.error === "invalid_bin") {
                        toast.error(getStrLang(lang.nameLang, "invalid_bin"))
                    } else if (err.response?.data?.error === "invalid_bin") {
                        toast.error(`${getStrLang(lang.nameLang, "invalid_card_type")}`)
                    } else if (err.response?.data?.error === "invalid_document_id") {
                        toast.error(`${getStrLang(lang.nameLang, "invalid_doc_id")} ${err.response?.data?.document_needed}`)
                    } else {
                        toast.error(err.response?.data?.error)
                    }
                    console.log(err.toString());
                }).finally(() => {
                    setLoadingInfo(false);
                    translate();
                });
        } else if (props.provider_name === "ccr") {///for cc raspay
            postRasPayCC(sessionStorage.getItem("order_no"), {
                "name": card_holder_name,
                "number": card_number,
                "cvv": cvv_number,
                "expirationMonth": expire_date.split("/")[0],
                "expirationYear": expire_date.split("/")[1],
                "address": {
                    "line1": "Avenida Paulista",
                    "line2": "1471",
                    "zip_code": formInput.zip_code,
                    "city": formInput.city,
                    "state": formInput.state,
                    "country": "BR"
                },
                "mobile_phone": {
                    "country_code": "55",
                    "area_code": "44",
                    "number": "998593816"
                },
                birthdate: formInput.birthdate,
                gender: formInput.gender,
            })
                .then(res => {
                    if (res !== undefined) {
                        setLoadingInfo(false)
                        if (res.redirectUrl) {
                            window.location = res.redirectUrl;
                        } else {
                            window.location.replace(getURLBackToPanel());
                        }
                    } else {

                    }
                })
                .catch(err => {
                    if (err.response?.data?.error === "invalid_bin") {
                        toast.error(getStrLang(lang.nameLang, "invalid_bin"))
                    } else if (err.response?.data?.error === "invalid_bin") {
                        toast.error(`${getStrLang(lang.nameLang, "invalid_card_type")}`)
                    } else if (err.response?.data?.error === "invalid_document_id") {
                        toast.error(`${getStrLang(lang.nameLang, "invalid_doc_id")} ${err.response?.data?.document_needed}`)
                    } else {
                        toast.error(err.response?.data?.error)
                    }
                    console.log(err.toString());
                }).finally(() => {
                    setLoadingInfo(false);
                    translate();
                });
        }else if (props.provider_name === "CCA") { ///for cc Asaas
            postAsaasCC(sessionStorage.getItem("order_no"), {
                "name": card_holder_name,
                "number": card_number,
                "cvv": cvv_number,
                "expirationMonth": expire_date.split("/")[0],
                "expirationYear": expire_date.split("/")[1],
                "instalment": instalment,
            })
                .then(res => {
                    if (res !== undefined) {
                        setLoadingInfo(false)
                        if (res.redirectUrl) {
                            window.location = res.redirectUrl;
                        } else {
                            window.location.replace(getURLBackToPanel());
                        }
                    } else {

                    }
                })
                .catch(err => {
                    if (err.response?.data?.error === "invalid_bin") {
                        toast.error(getStrLang(lang.nameLang, "invalid_bin"))
                    } else if (err.response?.data?.error === "invalid_bin") {
                        toast.error(`${getStrLang(lang.nameLang, "invalid_card_type")}`)
                    } else if (err.response?.data?.error === "invalid_document_id") {
                        toast.error(`${getStrLang(lang.nameLang, "invalid_doc_id")} ${err.response?.data?.document_needed}`)
                    } else {
                        toast.error(err.response?.data?.error)
                    }
                    console.log(err.toString());
                }).finally(() => {
                    setLoadingInfo(false);
                    translate();
                });
        } else if (props.provider_name === "CCX") { ///for cc XoraPay
            postCCX(sessionStorage.getItem("order_no"), {
                "name": card_holder_name,
                "number": card_number,
                "cvv": cvv_number,
                "expirationMonth": expire_date.split("/")[0],
                "expirationYear": expire_date.split("/")[1],
                "full_address": addressData.full_address,
                "city": addressData.city,
                "state": addressData.state,
                "zip": addressData.zip,
            })
                .then(res => {
                    if (res !== undefined) {
                        setLoadingInfo(false)
                        if (res.status === 'REDIRECT' && res.redirect_url) {
                            // kick off 3DS iframe + polling
                            setRedirectUrl(res.redirect_url)
                            setTxnId(res.data?.data?.transaction_id || sessionStorage.getItem("order_no"))
                            setIs3DS(true)
                        } else if (res.status === 'SUCCESS') {
                            window.location.replace(getURLBackToPanel())
                        } else {
                            toast.error(res.message || 'Transaction failed')
                        }
                    }
                })
                .catch(err => {
                    if (err.response?.data?.error === "invalid_bin") {
                        toast.error(getStrLang(lang.nameLang, "invalid_bin"))
                    } else if (err.response?.data?.error === "invalid_card_type") {
                        toast.error(`${getStrLang(lang.nameLang, "invalid_card_type")}`)
                    } else if (err.response?.data?.error === "invalid_document_id") {
                        toast.error(`${getStrLang(lang.nameLang, "invalid_doc_id")} ${err.response?.data?.document_needed}`)
                    } else {
                        toast.error(err.response?.data?.error || err.response?.data?.message || 'Payment failed')
                    }
                    console.log(err.toString());
                }).finally(() => {
                    setLoadingInfo(false);
                    translate();
                });
        }

    }

    const postStripePaymentMethod = async (paymentMethodId) => {
        postStripeCC(sessionStorage.getItem("order_no"), {
            paymentMethodId
        }).then(res => {
            if (res !== undefined) {
                setLoadingInfo2(false)
                if (res.redirectUrl) {
                    window.location = res.redirectUrl;
                } else {
                    window.location.replace(getURLBackToPanel());
                }
            } else {

            }
        })
            .catch(err => {
                if (err.response?.data?.error === "invalid_bin") {
                    toast.error(getStrLang(lang.nameLang, "invalid_bin"))
                } else if (err.response?.data?.error === "invalid_bin") {
                    toast.error(getStrLang(lang.nameLang, "invalid_card_type"))
                } else if (err.response?.data?.error === "invalid_document_id") {
                    toast.error(`${getStrLang(lang.nameLang, "invalid_doc_id")} ${err.response?.data?.document_needed}`)
                } else {
                    toast.error(err.response?.data?.error)
                }
                console.log(err.toString());
            }).finally(() => {
                setLoadingInfo2(false);
                translate();
            });
    };

    useEffect(() => {
        let interval
        if (is3DS && txnId) {
            interval = setInterval(() => {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status && res.status.toLowerCase() === "paid") {
                            clearInterval(interval)
                            window.location.replace(getURLBackToPanel())
                        }
                    })
                    .catch(err => console.error(err))
            }, 10000)
        }
        return () => clearInterval(interval)
    }, [is3DS, txnId])

    const handleExpiryChange = (event) => {
        let input = event.target.value;
        input = input.replace(/[^0-9]/g, "");
        if (input.length > 7) {
            input = input.substr(0, 7);
        }
        if (input.length > 2) {
            input = input.substr(0, 2) + "/" + input.substr(2);
            const month = parseInt(input.substr(0, 2));
            if (month > 12) {
                input = "12/" + input.substr(3);
            }
        }
        setExpireDate(input);
    };
    const handleBirthdateChange = (event) => {
        const { value, inputType } = event.target;
        if (value.length < formInput.birthdate.length) {
            setFormInput({
                birthdate: value
            });
            return;
        }
        let input = value.replace(/[^0-9]/g, "");
        if (input.length > 8) {
            input = input.substr(0, 8);
        }
        if (input.length > 4) {
            input = input.substr(0, 4) + "-" + input.substr(4, 2) + "-" + input.substr(6);
        } else if (input.length > 2) {
            input = input.substr(0, 4) + "-" + input.substr(4);
        }
        setFormInput({
            birthdate: input
        });
    };

    const handleCvvChange = (event) => {
        let input = event.target.value;
        input = input.replace(/[^0-9]/g, "");
        if (input.length > 4) {
            input = input.substr(0, 4);
        }
        setCvvNumber(input);
    };

    const saveUserData = (e) => {
        e.preventDefault();
        setIsShowUserForm(false)
    }

    const handleInput = evt => {
        const name = evt.target.name;
        setFormInput({ [name]: evt.target.value });
    };

    const handleAddressInput = evt => {
        const name = evt.target.name;
        setAddressData({ [name]: evt.target.value });
    };

    const saveAddressData = (e) => {
        e.preventDefault();
        setShowAddressForm(false)
    }

    const backToAddressForm = () => {
        setShowAddressForm(true)
    }

    const backToForm = () => {
        setIsShowUserForm(true)
    }


    if (is3DS) {
        return (
            <div style={{ width: '100%', height:"600px" }}>
                <iframe
                    src={redirectUrl}
                    style={{ width: '100%', height:"600px", border: 'none' }}
                    title="3DS Authentication"
                />
            </div>
        )
    }

    return (
        <>
            <Toaster
                toastOptions={{
                    className: '',
                    style: {
                        border: '1px solid #0d4fb8',
                        color: '#0d4fb8',
                        padding: '12px',
                        top: '300px',
                        //  position: 'relative',
                    },
                }}
            />
            {loadingInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}
            {props.provider_name === "stripe_cc" &&
                <Elements stripe={stripePromise}>
                    <CheckoutForm lang={lang} postStripePaymentMethod={postStripePaymentMethod} setLoadingInfo={setLoadingInfo2} loadingInfo={loadingInfo2}/>
                </Elements>}
            {!loadingInfo && <div style={{ height: '100%' }}>
                {showAddressForm === true && props.provider_name === "CCX" ? <div className='row'>
                    {/* CCX Address form data */}
                    <div className='col-md-12 d-flex justify-content-center'>
                        <form style={{ minWidth: "70%" }} onSubmit={saveAddressData}>
                            <div className='form-group'>
                                <label htmlFor="full_address">{getStrLang(lang.nameLang, "address") || "Full Address"}</label>
                                <input type="text" className='form-control' id="full_address" name="full_address"
                                    placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "address") || "address"}`} 
                                    value={addressData.full_address} onChange={handleAddressInput} required />
                            </div>

                            <div className='form-group'>
                                <label htmlFor="city">{getStrLang(lang.nameLang, "city") || "City"}</label>
                                <input type="text" className='form-control' id="city" name="city"
                                    placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "city") || "city"}`} 
                                    value={addressData.city} onChange={handleAddressInput} required />
                            </div>

                            <div className='form-group'>
                                <label htmlFor="state">{getStrLang(lang.nameLang, "state") || "State"}</label>
                                <input type="text" className='form-control' id="state" name="state"
                                    placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "state") || "state"}`} 
                                    value={addressData.state} onChange={handleAddressInput} required />
                            </div>

                            <div className='form-group'>
                                <label htmlFor="zip">{getStrLang(lang.nameLang, "zip_code") || "ZIP Code"}</label>
                                <input type="text" className='form-control' id="zip" name="zip"
                                    placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "zip_code") || "ZIP code"}`} 
                                    value={addressData.zip} onChange={handleAddressInput} required />
                            </div>

                            <button className='btn btn-primary btn-block'>{getStrLang(lang.nameLang, "continue") || "Continue"}</button>
                        </form>
                    </div>
                </div> : isShowUserForm === true ? <div className='row'>
                    {/* user form data */}
                    <div className='col-md-12 d-flex justify-content-center'>
                        <form style={{ minWidth: "70%" }} onSubmit={saveUserData}>
                            <div className='form-group'>
                                <label htmlFor="gender">{getStrLang(lang.nameLang, "gender")}</label>
                                <select name="gender" id="gender" className='form-control' required onChange={handleInput} value={formInput.gender}>
                                    <option value="1">{getStrLang(lang.nameLang, "male")}</option>
                                    <option value="2">{getStrLang(lang.nameLang, "female")}</option>
                                </select>
                            </div>

                            <div className='form-group'>
                                <label htmlFor="birthdate">{getStrLang(lang.nameLang, "birthdate")}</label>
                                <input type="text" className='form-control' id="birthdate" name="birthdate"
                                    placeholder={`YYYY-MM-DD`} value={formInput.birthdate} onChange={handleBirthdateChange} required />
                            </div>

                            <div className='form-group'>
                                <label htmlFor="zip_code">{getStrLang(lang.nameLang, "zip_code")}</label>
                                <input type="text" className='form-control' id="zip_code" name="zip_code"
                                    placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "zip_code")}`} value={formInput.zip_code} onChange={handleInput} required />
                            </div>

                            <div className='form-group'>
                                <label htmlFor="city">{getStrLang(lang.nameLang, "city")}</label>
                                <input type="text" className='form-control' id="city" name="city"
                                    placeholder={`${getStrLang(lang.nameLang, "enter")} ${getStrLang(lang.nameLang, "city")}`} value={formInput.city} onChange={handleInput} required />
                            </div>

                            <div className='form-group'>
                                <label htmlFor="state">{getStrLang(lang.nameLang, "state")}</label>
                                <select name="state" id="state" className='form-control' required onChange={handleInput} value={formInput.state}>
                                    <option value="AC">Acre</option>
                                    <option value="AL">Alagoas</option>
                                    <option value="AP">Amapá</option>
                                    <option value="AM">Amazonas</option>
                                    <option value="BA">Bahia</option>
                                    <option value="CE">Ceará</option>
                                    <option value="DF">Distrito Federal</option>
                                    <option value="ES">Espírito Santo</option>
                                    <option value="GO">Goiás</option>
                                    <option value="MA">Maranhão</option>
                                    <option value="MT">MatoGrosso</option>
                                    <option value="MS">MatoGrosso do Sul</option>
                                    <option value="MG">Minas Gerais</option>
                                    <option value="PA">Pará</option>
                                    <option value="PB">Paraíba</option>
                                    <option value="PR">Paraná</option>
                                    <option value="PE">Pernambuco</option>
                                    <option value="PI">Piauí</option>
                                    <option value="RJ">Rio de Janeiro</option>
                                    <option value="RN">Rio Grande do Norte</option>
                                    <option value="RS">Rio Grande do Sul</option>
                                    <option value="RO">Rondônia</option>
                                    <option value="RR">Roraima</option>
                                    <option value="SC">Santa Catarina</option>
                                    <option value="SP">São Paulo</option>
                                    <option value="SE">Sergipe</option>
                                    <option value="TO">Tocantins</option>
                                </select>
                            </div>
                            <button className='btn btn-primary btn-block'>{getStrLang(lang.nameLang, "Save")}</button>
                        </form>
                    </div>
                </div> : props.provider_name !== "stripe_cc" &&
                <div className='row'>
                    {/* user card data */}
                    {props.provider_name === "ccr" && <div className="column-pix-sides">
                        <button className="btn-split-pix" onClick={backToForm}><IoChevronBackOutline size={25} /> {getStrLang(lang.nameLang, "btn_voltar")}</button>
                    </div>}
                    {props.provider_name === "CCX" && <div className="column-pix-sides">
                        <button className="btn-split-pix" onClick={backToAddressForm}><IoChevronBackOutline size={25} /> {getStrLang(lang.nameLang, "btn_voltar") || "Back"}</button>
                    </div>}

                    <div className='col-md-12 d-flex justify-content-center'>
                        <form onSubmit={callCard} style={{ minWidth }}>
                            <div className='form-group'>
                                <label htmlFor="card_holder_name">{getStrLang(lang.nameLang, "card_holder_name")}</label>
                                <input type="text" className='form-control' id="card_holder_name" name="card_holder_name" value={card_holder_name}
                                    placeholder={getStrLang(lang.nameLang, "enter_holder_name")} onChange={(e) => setCardHolderName(e.target.value)} required />
                            </div>
                            <div className='form-group'>
                                <label htmlFor="card_number">{getStrLang(lang.nameLang, "card_number")}</label>
                                <input type="text" className='form-control' id="card_number" name="card_number"
                                    placeholder={getStrLang(lang.nameLang, "enter_card_number")} value={card_number} onChange={(e) => setCardNumber(e.target.value)} required />
                            </div>
                            <div className='form-group'>
                                <label htmlFor="cvv_number">{getStrLang(lang.nameLang, "cvv_number")}</label>
                                <input type="text" className='form-control' id="cvv_number" name="cvv_number" placeholder="123" value={cvv_number} onChange={handleCvvChange} required />
                            </div>
                            <div className='form-group'>
                                <label htmlFor="expire_date">{getStrLang(lang.nameLang, "expire_date")}</label>
                                <input type="text" className='form-control' id="expire_date" name="expire_date" value={expire_date} onChange={handleExpiryChange}
                                    required
                                    placeholder="MM/YYYY"
                                    minLength="7"
                                    maxLength="7"
                                    autoComplete="cc-exp" />
                            </div>
 
                                    {props.provider_name === "CCA" && (
                                        <InstalmentControl
                                            lang={lang}
                                            min={1}
                                            max={12}
                                        />
                                    )}

                            <button type='submit' className='btn btn-primary btn-block'>{getStrLang(lang.nameLang, "pay")}</button>
                        </form>
                    </div>
                </div>}

            </div>}

        </>)
}


export default StripeCC;